import { FileDownloadService } from '@/services/abstract/poc/FileDownloadService';
import { uint8ArrayToBlob } from '@/services/poc/dataUtils';

const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export class FileDownloadServiceImpl extends FileDownloadService {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this -- implements abstract contract; no instance state needed
  saveBytes(
    data: Uint8Array,
    filename: string,
    mimeType = 'application/octet-stream'
  ): void {
    triggerBlobDownload(uint8ArrayToBlob(data, mimeType), filename);
  }

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this -- implements abstract contract; no instance state needed
  saveBlob(blob: Blob, filename: string): void {
    triggerBlobDownload(blob, filename);
  }
}
